var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 301,
    viewBox: "0 0 298 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.606 84.8021L158.116 126.955L198.733 137.071L157.812 145.879L147.953 187.737L139.444 145.584L98.8263 135.467L139.748 126.66L149.606 84.8021Z",
    fill: "#CB37FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.527 84.0105C153.155 82.1678 151.55 80.8328 149.67 80.8026C147.791 80.7724 146.144 82.0552 145.713 83.8851L136.434 123.281L97.9847 131.557C96.1656 131.948 94.8567 133.543 94.8269 135.403C94.797 137.264 96.054 138.899 97.8596 139.349L136.024 148.854L144.033 188.528C144.405 190.371 146.01 191.706 147.889 191.736C149.769 191.766 151.416 190.483 151.847 188.654L161.126 149.257L199.575 140.982C201.394 140.59 202.703 138.996 202.733 137.136C202.763 135.275 201.506 133.64 199.7 133.19L161.536 123.684L153.527 84.0105Z",
    stroke: "#CB37FF",
    strokeWidth: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.527 84.0105C153.155 82.1678 151.55 80.8328 149.67 80.8026C147.791 80.7724 146.144 82.0552 145.713 83.8851L136.434 123.281L97.9847 131.557C96.1656 131.948 94.8567 133.543 94.8269 135.403C94.797 137.264 96.054 138.899 97.8596 139.349L136.024 148.854L144.033 188.528C144.405 190.371 146.01 191.706 147.889 191.736C149.769 191.766 151.416 190.483 151.847 188.654L161.126 149.257L199.575 140.982C201.394 140.59 202.703 138.996 202.733 137.136C202.763 135.275 201.506 133.64 199.7 133.19L161.536 123.684L153.527 84.0105Z",
    stroke: "#EAF408",
    strokeWidth: 8,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_272",
    x: 0.184898,
    y: 0.663218,
    width: 297.19,
    height: 300.217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.5026
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.3207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.956863 0 0 0 0 0.0313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_272",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPurple);
export default __webpack_public_path__ + "static/media/Star_Purple.195bf9bf37bc5dffa349fb9d3bb406cb.svg";
export { ForwardRef as ReactComponent };